import { render, staticRenderFns } from "./SdCard.html?vue&type=template&id=1ccd83a2&external"
import script from "./SdCard.ts?vue&type=script&lang=ts&external"
export * from "./SdCard.ts?vue&type=script&lang=ts&external"
import style0 from "./SdCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports